import { Component, EventEmitter, inject, Input, OnInit, Output, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { SubTask, Task, TaskTypeForms } from '@k12/models';

interface AwardAcceptanceFormData {
  studentName?: string | null;
  awardAmount?: string | null;
  programTypeId?: number | null;
  programTypeCode?: string | null;
  householdId?: string | null;
  programPartnerId?: string | null;
  studentId?: string | null;
  academicYearId?: number | null;
  isAwardAccepted?: boolean | null;
}

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'lib-award-acceptance-form',
  standalone: true,
  imports: [ReactiveFormsModule, MatButtonModule, MatCardModule, MatInputModule, MatRadioModule],
  templateUrl: './award-acceptance-form.component.html',
  styleUrl: './award-acceptance-form.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class AwardAcceptanceFormComponent implements OnInit {
  @Input() task!: Task;
  @Input() taskAction!: SubTask | null;
  @Input() taskTypeAction!: TaskTypeForms;
  @Output() submitFormData = new EventEmitter<string>();

  private readonly fb = inject(FormBuilder);

  protected form!: FormGroup;
  protected context: AwardAcceptanceFormData = {};

  public ngOnInit(): void {
    const raw = this.taskAction?.formData ? (JSON.parse(this.taskAction.formData) as Record<string, unknown>) : {};

    this.context = this.normalizeKeys(raw) as AwardAcceptanceFormData;

    this.form = this.fb.group({
      studentName: [{ value: this.context.studentName ?? '', disabled: true }],
      awardAmount: [{ value: this.context.awardAmount ?? '', disabled: true }],
      programTypeCode: [{ value: this.context.programTypeCode ?? '', disabled: true }],
      isAwardAccepted: [this.context.isAwardAccepted ?? null, Validators.required]
    });
  }

  private normalizeKeys(raw: Record<string, unknown>): Record<string, unknown> {
    return Object.fromEntries(Object.entries(raw).map(([k, v]) => [k.charAt(0).toLowerCase() + k.slice(1), v]));
  }

  protected isFormReady(): boolean {
    return this.form.valid && this.form.dirty;
  }

  protected onBack(): void {
    globalThis.history.back();
  }

  protected submitForm(): void {
    if (!this.isFormReady()) return;

    this.submitFormData.emit(
      JSON.stringify({
        ...this.context,
        isAwardAccepted: this.form.getRawValue().isAwardAccepted as boolean
      })
    );
  }
}
